import { Icon } from '@mirai-kids-monte/core/src/components/dataDisplay/Icon';
import ExportedImage from 'next-image-export-optimizer';
import { type BlogMetaData } from '../../../constants/BlogsMetadata';
import styles from './index.module.scss';

type Props = {
  blogMetadata: BlogMetaData;
};

export const Card = ({ blogMetadata }: Props) => (
  <a href={blogMetadata.filePath}>
    <div className={styles.base}>
      <div className={styles['caption-wrapper']}>
        <Icon name="Book" size={10} />
        <span className={styles.caption}>あわせて読みたい</span>
      </div>
      <div className={styles['image-wrapper']}>
        <ExportedImage
          src={blogMetadata.thumbnailUrl}
          alt={blogMetadata.title}
          className={styles.image}
          width={400}
          height={300}
          loading="lazy"
        />
      </div>
      <div className={styles['blog-title']}>{blogMetadata.title}</div>
    </div>
  </a>
);
